import { render, staticRenderFns } from "./UpNavbar.vue?vue&type=template&id=7ff0ab20&"
import script from "./UpNavbar.vue?vue&type=script&lang=js&"
export * from "./UpNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports